export const StateDivisions = {
  Punjab: {
    MAJHA: "Majha",
    MALWA: "Malwa",
    DOABA: "Doaba",
    PUADH: "Puadh",
  },
  Haryana: {
    "AMBALA DIVISION": "Ambala Division",
    "ROHTAK DIVISION": "Rohtak Division",
    "GURGAON DIVISION": "Gurgaon Division",
    "HISAR DIVISION": "Hisar Division",
  },
  Rajasthan: {
    AJMER: "Ajmer Division",
    BHARATPUR: "Bharatpur Division",
    BIKANER: "Bikaner Division",
    JAIPUR: "Jaipur Division",
    JODHPUR: "Jodhpur Division",
    KOTA: "Kota Division",
    UDAIPUR: "Udaipur Division",
  },
  "Uttar Pradesh": {
    AGRA: "Agra Division",
    ALLAHABAD: "Prayagraj (Allahabad) Division",
    AZAMGARH: "Azamgarh Division",
    BAREILLY: "Bareilly Division",
    CHITRAKOOT: "Chitrakoot Division",
    FAIZABAD: "Faizabad Division",
    GORAKHPUR: "Gorakhpur Division",
    JHANSI: "Jhansi Division",
    KANPUR: "Kanpur Division",
    LUCKNOW: "Lucknow Division",
    MEERUT: "Meerut Division",
    MIRZAPUR: "Mirzapur Division",
    MORADABAD: "Moradabad Division",
    SAHARANPUR: "Saharanpur Division",
    VARANASI: "Varanasi Division",
  },
};
